const ACTION_PREFIX = 'location';
export const LocationActionTypes = {
  LOCATION_CHANGE: `${ACTION_PREFIX}/LOCATION_CHANGE`,
};

export function locationChange(location = '/') {
  return {
    type: LocationActionTypes.LOCATION_CHANGE,
    payload: location,
  };
}

export const updateLocation = ({ dispatch }) => {
  return nextLocation => dispatch(locationChange(nextLocation));
};

export const LocationActions = {
  locationChange,
  updateLocation,
};
